// Licensed under the MIT license.

export const name = "@microsoft/teamsfx";
export const version = "0.1.0";
